import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";
import {SendLetterModel} from "../Models/SendLetterModel";

export interface IButtonControllerOptions {
    label: string;
    onClick: () => void;
    name?: string;
}

export class ButtonController extends AnimationBaseController {
    $model: SendLetterModel;
    private isInteractive = false;

    public constructor(@Inject private _options: IButtonControllerOptions) {
        super(_options.name);
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            childControllers: {},
            modelWatch: {},
            modelEvents: {
                "allowSend": () => {

                    //this.display.interactive = true;
                    this.isInteractive = true;
                    this.gotoAndStop("up");
                },
                "win": () => {
                    this.isInteractive = false;
                    //this.display.interactive = false;
                }
            },
            queue: {},
            onPointerDown: (e) => {

                if(!this.isInteractive) {
                   //e.stopPropagation();
                   return;
                }

                this.gotoAndStop("down");
                this._options.onClick();

            },
            onPointerUp: (e) => {
                if(!this.isInteractive) {
                    //e.stopPropagation();
                    return;
                }
                this.gotoAndStop("up");
            },
            onPointerUpOutside: (e) => {
                if(!this.isInteractive) {
                    //e.stopPropagation();
                    return;
                }
                this.gotoAndStop("up");
            },
            onPointerOut: (e) => {
                if(!this.isInteractive) {
                    //e.stopPropagation();
                    return;
                }
                this.gotoAndStop("up");
            },
            onPointerOver: (e) => {
                if(!this.isInteractive) {
                    //e.stopPropagation();
                    return;
                }
                this.gotoAndStop("over");
            }
        };
    }

    protected onInitialize(): void {

        //this.display.interactive = false;
        this.gotoAndStop("disable");

    }
}

